import { Inject, Injectable, InjectionToken, ValueProvider } from '@angular/core';
import { AnalyticsService } from '@rci/analytics-service';
import { ExternalScript, MiscService } from '@rci/misc-service';
import { StateService } from '@rci/state-service';
import { UserMonitoringService } from '@rci/user-monitoring-service';

export interface AppInitializerServiceConfig {
  externalScripts: ExternalScript[];
}

export const SELF_SERVE_APP_INITIALIZER_SERVICE_CONFIG = new InjectionToken<AppInitializerServiceConfig>(
  'AppInitializerServiceConfig',
);

@Injectable({
  providedIn: 'root',
})
export class SelfServeAppInitializerService {
  constructor(
    @Inject(SELF_SERVE_APP_INITIALIZER_SERVICE_CONFIG) private readonly config: AppInitializerServiceConfig,
    private readonly stateService: StateService,
    private readonly miscService: MiscService,
    private readonly analyticsService: AnalyticsService,
    private readonly rumService: UserMonitoringService,
  ) {}

  static configure(config?: AppInitializerServiceConfig): ValueProvider {
    return {
      provide: SELF_SERVE_APP_INITIALIZER_SERVICE_CONFIG,
      useValue: config || {},
    };
  }

  bootstrap(): Promise<any> {
    return Promise.all([
      this.bootstrapExternalScripts(),
      this.stateService.bootstrap().then(() => {
        this.rumService.bootstrap();
        this.analyticsService.bootstrap();
      }),
    ]);
  }

  private bootstrapExternalScripts() {
    // inject external scripts one by one, waiting for the ones marked with `isWaitUntilLoaded`
    return this.config.externalScripts.reduce(
      (acc, externalScript) => acc.then(() => this.miscService.injectExternalScript(externalScript)),
      this.miscService.promiseDocumentReady(),
    );
  }
}
